import type { TourDefinition } from '../../training/tours';

/**
 * Тур програвача уроку (`/kb/learning/lessons/:id`). Цілі — атрибути data-tour на екрані програвача:
 * lesson-progress, lesson-step, lesson-answer, lesson-practice, lesson-nav.
 * Зареєстровано в features/training/tours.ts; у програвачі тур запускає кнопка «Як це працює».
 */
export const LESSON_PLAYER_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Урок',
  summary: 'Як проходити урок: кроки, відповіді на питання, практика в навчальному проєкті й завершення.',
  missingHint: 'Відкрийте будь-який урок курсу — підказки прив’яжуться до його елементів.',
  steps: [
    {
      id: 'progress',
      target: 'lesson-progress',
      title: 'Кроки уроку',
      body: 'Кожен сегмент — один крок. Пройдені позначено галочкою, поточний — рамкою. Натисніть сегмент, щоб перейти до кроку.',
      placement: 'bottom',
    },
    {
      id: 'step',
      target: 'lesson-step',
      title: 'Один крок на екрані',
      body: 'Прочитайте текст, перегляньте відео чи схему й позначте крок пройденим. Урок зараховується, коли пройдено всі обов’язкові кроки.',
    },
    {
      id: 'answer',
      target: 'lesson-answer',
      title: 'Перевірка знань',
      body: 'Відповідь перевіряється одразу, а пояснення показує, де в правилах фірми відповідь. Неправильну відповідь можна повторити.',
    },
    {
      id: 'practice',
      target: 'lesson-practice',
      title: 'Практика без ризику',
      body: 'Практичний крок виконується в навчальному проєкті з вигаданими задачами — дані не потрапляють у звіти й показники. Система сама бачить виконану дію й зараховує крок.',
    },
    {
      id: 'nav',
      target: 'lesson-nav',
      title: 'Навігація',
      body: 'Кнопки «Назад» і «Далі» або стрілки ← → на клавіатурі. На останньому кроці — «Завершити урок» і перехід до наступного уроку курсу.',
      placement: 'top',
    },
  ],
};
